var SmoothScroll = {
    conf: {
        animSpeed: 400,
        headHeight: 0
    },
    init: function(n, elem, speed, headerH) {
        var self = this;
        var conf = self.conf;
        switch(n) {
            case "":
                $('a[href^=#]').click(function() {
                    conf.headHeight = (elem==null)?0:$(elem).outerHeight();
                    var speed = conf.animSpeed;
                    var href;
                    href = $(this).attr("href");
                    var target = $(href == "#" || href == "" ? 'html' : href);
                    var position = (target.offset().top) - conf.headHeight;
                    $('html,body').animate({scrollTop:position}, speed, 'swing',function(){return false;});
                    return false;
                });
                break;
        }
    }
};

module.exports = SmoothScroll;